export enum Languages {
  'en' = 'en',
  'es' = 'es',
  'it' = 'it',
}
